import React, { useState } from "react";
import Footer from "src/common/layouts/footer/Footer";
import { indexWrapCss } from "./css/Author.style";
import { formInputCss } from "./css/RegisterAuthor.style";
import Header from "src/common/layouts/header/Header";
import "cropperjs/dist/cropper.css";
import PortoneTest from "./PortoneTest";
import { useIsMobile } from "../../hooks/useIsMobile";
import ExtraFieldsSection from "./components/ExtraFieldsSection";
import CharCount from "./components/CharCount";
import EmailVerificationSection from "./components/EmailVerificationSection";
import SnsLinksSection from "./components/SnsLinksSection";
import RepresentativeBookSection from "./components/RepresentativeBookSection";
import KeywordSection from "./components/KeywordSection";
import ProfilePhotoSection from "./components/ProfilePhotoSection";
import RegisterAuthorAlerts from "./components/RegisterAuthorAlerts";
import { useAuthorRegisterForm } from "./hooks/useAuthorRegisterForm";

const RegisterAuthorPage_new = () => {
    const isMobile = useIsMobile();
    const [search, setSearch] = useState<any>([]);
    const onSearchHandler = (e: any) => setSearch(e.target.value);

    const form = useAuthorRegisterForm();

    return (
        <div css={indexWrapCss}>
            <Header onChange={onSearchHandler} searchValue={search} name="search" activeFlag="" />

            <RegisterAuthorAlerts
                showMidAlert={form.showMidAlert}
                setShowMidAlert={form.setShowMidAlert}
                setShowExtraFields={form.setShowExtraFields}
                doSubmit={form.doSubmit}
                showStep1BackAlert={form.showStep1BackAlert}
                setShowStep1BackAlert={form.setShowStep1BackAlert}
                setIsSubmitted={form.setIsSubmitted}
                showBackAlert={form.showBackAlert}
                setShowBackAlert={form.setShowBackAlert}
                showAlert={form.showAlert}
                setShowAlert={form.setShowAlert}
                showExtraFields={form.showExtraFields}
            />

            {/* 히어로 섹션 */}
            <div
                style={{
                    background: "linear-gradient(180deg, #e8f8f0 0%, #edf9f3 40%, #fafafa 100%)",
                }}
                className="w-full pt-12 pb-14 md:pt-8 md:pb-10 px-4"
            >
                <div className="max-w-[700px] mx-auto flex flex-col items-center text-center gap-3">
                    <h1
                        className={`font-bold text-[#222] leading-tight ${isMobile ? "text-[24px]" : "text-[32px]"}`}
                    >
                        ✏️ 작가 등록
                    </h1>
                </div>
            </div>

            {/* 폼 카드 영역 */}
            <div
                className={
                    isMobile
                        ? "flex flex-col px-4 gap-6 py-8 w-full"
                        : "flex justify-center py-12 px-4"
                }
            >
                <div
                    className={
                        isMobile
                            ? ""
                            : "w-full max-w-[780px] bg-white rounded-2xl border border-[#f0f0f0] shadow-sm p-10"
                    }
                >
                    <form
                        onSubmit={form.handleSubmit}
                        css={formInputCss}
                        className={isMobile ? "flex flex-col gap-6" : "flex flex-col gap-8"}
                    >
                        <label className="flex flex-col gap-3" id="authorName">
                            <div className="flex flex-row">
                                <span className="title">이름</span>
                            </div>
                            <PortoneTest
                                ref={form.realNameInputRef}
                                authorEmail={form.authorEmail}
                                authorName={form.authorName}
                                setAuthorName={form.setAuthorName}
                                setIsRealNameVerified={form.setIsRealNameVerified}
                                setRealNameAuthError={form.setRealNameAuthError}
                                isInitiallyVerified={form.isRealNameVerifiedFromServer}
                                isVerificationStatusLoading={form.isRealNameStatusLoading}
                            />
                            {(form.errors.name || form.realNameAuthError) && (
                                <p className="font-namsan text-[12px] font-bold text-red-500 whitespace-pre-line">
                                    {form.errors.name || form.realNameAuthError}
                                </p>
                            )}
                        </label>
                        {/* 이름 */}

                        <EmailVerificationSection
                            isMobile={isMobile}
                            authorEmail={form.authorEmail}
                            setAuthorEmail={form.setAuthorEmail}
                            emailError={form.errors.email}
                            emailRef={form.emailRef}
                            handleEmailVerification={form.handleEmailVerification}
                            emailVerificationButtonClick={form.emailVerificationButtonClick}
                            isEmailVerified={form.isEmailVerified}
                            emailMsg={form.emailMsg}
                            emailVerificationCode={form.emailVerificationCode}
                            setEmailVerificationCode={form.setEmailVerificationCode}
                            codeError={form.errors.code}
                            codeRef={form.codeRef}
                            handleEmailVerificationCheck={form.handleEmailVerificationCheck}
                            isEmailCheck={form.isEmailCheck}
                            emailCheck={form.emailCheck}
                        />

                        <SnsLinksSection
                            isMobile={isMobile}
                            instarLink={form.instarLink}
                            setInstarLink={form.setInstarLink}
                            instarError={form.errors.instarLink}
                            instarRef={form.instarRef}
                            twitterLink={form.twitterLink}
                            setTwitterLink={form.setTwitterLink}
                            twitterError={form.errors.twitterLink}
                            twitterRef={form.twitterRef}
                            blogLink={form.blogLink}
                            setBlogLink={form.setBlogLink}
                            blogError={form.errors.blogLink}
                            blogRef={form.blogRef}
                            brunchLink={form.brunchLink}
                            setBrunchLink={form.setBrunchLink}
                            brunchError={form.errors.brunchLink}
                            brunchRef={form.brunchRef}
                            snsLinks={form.snsLinks}
                            onSnsLinkChange={form.handleSnsLinkChange}
                            onLinkAdd={form.handleLinkAdd}
                            snsExtraError={form.errors.snsExtra}
                        />

                        <label
                            className={`flex flex-col gap-4 ${!isMobile ? "mt-[30px]" : ""}`}
                            id="authorIntro"
                        >
                            <div className="">
                                <span className="title">작가님을 한 마디로 소개해 주세요.</span>
                            </div>
                            <div className="flex-grow">
                                <textarea
                                    ref={form.introRef}
                                    className={
                                        isMobile
                                            ? `appearance-none h-52 w-full font-namsan border ${form.errors.intro ? "border-red-500 placeholder-red-500 focus:outline-red-500" : "border-extra placeholder-[#5E676E] focus:outline-input"} rounded py-3 px-4 leading-tight focus:text-black`
                                            : `appearance-none font-namsan border ${form.errors.intro ? "border-red-500 placeholder-red-500 focus:outline-red-500" : "border-extra placeholder-[#5E676E] focus:outline-input"} rounded py-3 px-4 leading-tight focus:text-black`
                                    }
                                    style={isMobile ? {} : { width: "100%", height: "80px" }}
                                    value={form.authorIntro}
                                    maxLength={1000}
                                    placeholder="작가님을 한 마디로 나타낸다면 어떤 표현이 가장 잘 어울릴까요?"
                                    onChange={(e) => form.setAuthorIntro(e.target.value)}
                                />
                                <CharCount
                                    current={form.authorIntro.length}
                                    max={1000}
                                    error={form.errors.intro}
                                    style={isMobile ? {} : { width: "100%" }}
                                />
                            </div>
                        </label>

                        <label className="flex flex-col gap-4" id="authorDescription">
                            <p className="title">작가님에 대해 조금 더 자세히 들려주세요.</p>
                            <div className="flex-grow">
                                <textarea
                                    ref={form.descRef}
                                    className={
                                        isMobile
                                            ? `appearance-none w-full h-72 font-namsan border ${form.errors.desc ? "border-red-500 placeholder-red-500 focus:outline-red-500" : "border-extra placeholder-[#5E676E] focus:outline-input"} rounded py-3 px-4 leading-tight focus:text-black mb-3`
                                            : `appearance-none font-namsan border ${form.errors.desc ? "border-red-500 placeholder-red-500 focus:outline-red-500" : "border-extra placeholder-[#5E676E] focus:outline-input"} rounded py-3 px-4 leading-tight focus:text-black`
                                    }
                                    style={isMobile ? {} : { width: "100%", height: "250px" }}
                                    value={form.authorDescription}
                                    onChange={(e) => form.setAuthorDescription(e.target.value)}
                                    placeholder="작가님에 대해 조금 더 자세히 이야기 해주실 수 있을까요?"
                                    maxLength={1000}
                                />
                                <CharCount
                                    current={form.authorDescription.length}
                                    max={1000}
                                    error={form.errors.desc}
                                    style={isMobile ? {} : { width: "100%" }}
                                />
                            </div>
                        </label>

                        <RepresentativeBookSection
                            isMobile={isMobile}
                            representativeBookTitle={form.representativeBookTitle}
                            setRepresentativeBookTitle={form.setRepresentativeBookTitle}
                            bookTitleError={form.errors.bookTitle}
                            titleRef={form.titleRef}
                            representativeBookLink={form.representativeBookLink}
                            setRepresentativeBookLink={form.setRepresentativeBookLink}
                            bookLinkError={form.errors.bookLink}
                            linkRef={form.linkRef}
                        />

                        <KeywordSection
                            isMobile={isMobile}
                            keywords={form.keywords}
                            selectedKeywords={form.selectedKeywords}
                            toggleKeyword={form.toggleKeyword}
                            keywordError={form.errors.keyword}
                            keywordRef={form.keywordRef}
                        />

                        <ProfilePhotoSection
                            profilePreview={form.profilePreview}
                            profileError={form.errors.profile}
                            profileRef={form.profileRef}
                            fileInputProfileRef={form.fileInputProfileRef}
                            handleFileChange={form.handleFileChange}
                            showImageCrop={form.showImageCrop}
                            closeImageCrop={form.closeImageCrop}
                            image={form.image}
                            handleCrop={form.handleCrop}
                        />

                        {/* 추가 질문 섹션 */}
                        {form.showExtraFields && (
                            <div id="extra-fields-section">
                                <ExtraFieldsSection
                                    desktop={!isMobile}
                                    {...form.extraFieldsProps}
                                />
                            </div>
                        )}

                        <div className="flex flex-col items-center justify-center gap-3 mt-6">
                            <button
                                className="w-full h-[52px] font-bold bg-white text-[#19cf7a] border border-[#19cf7a] hover:bg-[#f0fdf6] text-[16px] rounded-full transition-colors"
                                type="button"
                                onClick={form.scrollToTop}
                            >
                                맨 위에서부터 다시 검토!
                            </button>
                            <button
                                className="w-full h-[52px] bg-[#19cf7a] font-bold hover:bg-[#00b368] text-white text-[16px] rounded-full shadow-[0px_4px_6px_rgba(25,207,122,0.2)] transition-colors"
                                type="submit"
                            >
                                {form.authorRegSubmitButtonClick
                                    ? "제출중..."
                                    : "작가 등록 신청하기"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default RegisterAuthorPage_new;
